import React from "react";
import PropTypes from "prop-types";
import "./styles.scss";

const Column = ({
  classIn,
  longTxt,
  childrenDesktop,
  showInResponsive,
  rest,
  childrenResponsive,
}) => {
  return (
    <div className={`customTable__table-column ${classIn}`} {...rest}>
      {showInResponsive && (
        <div className="customTable__table-column--mobile">
          <div
            className={`customTable__table-${classIn}  ${
              longTxt ? "overflow-text" : ""
            }`}
          >
            {childrenResponsive}
          </div>
        </div>
      )}
      <div
        className={`customTable__table-column--desktop ${
          longTxt ? "overflow-text" : ""
        }`}
      >
        {childrenDesktop}
      </div>
    </div>
  );
};

Column.defaultProps = {
  classIn: "",
  longTxt: false,
  childrenDesktop: null,
  childrenResponsive: null,
  showInResponsive: false,
};

Column.propTypes = {
  classIn: PropTypes.string,
  longTxt: PropTypes.bool,
  childrenDesktop: PropTypes.any,
  childrenResponsive: PropTypes.any,
  showInResponsive: PropTypes.bool,
};

export default Column;
